import { createBrowserRouter, Navigate } from 'react-router-dom';
import { AppShell } from './layouts/AppShell';
import { PathwayEditor } from './views/PathwayEditor';
import { Architecture } from './views/Architecture';
import { Scheduling } from './views/Scheduling';
import { ClinicalDesk } from './views/ClinicalDesk';
import { PathwayView } from './views/PathwayView';
import { PROMs } from './views/PROMs';
import { SessionCapture } from './views/SessionCapture';
import { LearningLoop } from './views/LearningLoop';

/**
 * Router - PROD-578.
 *
 * Eight tab routes wired to the AppShell parent layout. Tab order is
 * load-bearing per ORIGINAL-PROTOTYPE-PROMPTS Prompt 1 + 11 + 14; the order
 * here matches `src/layouts/TabNav.tsx#TABS`. Don't reorder.
 *
 * Default route ("/") renders PathwayStudio (canonical landing per master
 * prompt v3.3 §What to Build §1).
 */
export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <PathwayEditor /> },
      { path: 'architecture', element: <Architecture /> },
      { path: 'scheduling', element: <Scheduling /> },
      { path: 'clinical-desk', element: <ClinicalDesk /> },
      { path: 'pathway-view', element: <PathwayView /> },
      { path: 'proms', element: <PROMs /> },
      { path: 'session-capture', element: <SessionCapture /> },
      { path: 'learning-loop', element: <LearningLoop /> },
      // Any other path falls back to the default tab.
      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
